/**
 * #327/#4564: the one body an RBAC gate answers with when the permission
 * STORE failed (a D1 fault on the role, grant or override read), as opposed
 * to a decision that the caller may not see something.
 *
 * It is still fail-closed: the request is refused with a 403. But the body
 * says the refusal is a fault, so the client (src/client/lib/api-error.ts,
 * isRbacStoreOutage) retries it once and never files it as "your role cannot
 * see this". The coarse path gate (middleware/rbac.ts) and the capability
 * authoriser (lib/ostendo-authorizer.ts) both write these constants and the
 * client reads them, so the three cannot drift apart.
 */
export const RBAC_STORE_OUTAGE_ERROR = "Access check failed";
export const RBAC_STORE_OUTAGE_MESSAGE = "Could not verify your permissions — please retry.";
